export const rotasSeguros = [
  {
    path: "/seguros",
    name: "Seguros",
    component: () => import("@/views/Seguros/listarSeguros.vue"),
    meta: {
      obraObrigatoria: true,
      title: "Risco de Engenharia",
      icon: "mdi-clipboard-text-multiple-outline",
      subject: ["SEGUROS"],
      showMenu: true,
      grupo: "seguro",
      grupoTitle: "Seguros",
    },
  },
  {
    path: "/seguros/perfeito",
    name: "Pleno Funcionamento",
    component: () => import("@/views/Seguros/ListarSeguroPerfeitoFuncionamento.vue"),
    meta: {
      obraObrigatoria: true,
      title: "Pleno funcionamento",
      icon: "mdi-clipboard-text-multiple-outline",
      subject: ["SEGUROS_PLENO"],
      showMenu: true,
      grupo: "seguro",
      grupoTitle: "Seguros",
    },
  },
];
